<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-29 16:49:04
 * @LastEditTime: 2023-08-23 16:25:19
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <ul class="mainmenu">
        <li class=" has-menu-child-item">
           <router-link :to="{name:'Home',params:{lang:$i18n.locale}}">{{$t('home.title')}}</router-link>
        </li>
        <li class="with-megamenu has-menu-child-item">
            <a href="javascript:;">
                {{$t('solution.title')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div class="rn-megamenu">
                <div class="container wrapper">
                    <h4 class="title">
                        <span>{{$t('solution.subTitle')}}</span>
                        <!-- <span class="remark">INDUSTRY</span> -->
                    </h4>
                    <div class="row row--0">
                        <div class="col-lg-5 col-md-5">
                            <h4 class="title sub-title mt--10">Dynamics CRM</h4>
                            <Separator class="mb--30 mlr--30" style="background: #E0E2E9;" />
                            <ul class="submenu row row--0  pl--0">
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'CrmSemiconductor',params:{lang:$i18n.locale}}">{{$t('solution_crm.semiconductor.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'CrmHighTech',params:{lang:$i18n.locale}}">{{$t('solution_crm.high-tech.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'CrmElecConsume',params:{lang:$i18n.locale}}">{{$t('solution_crm.e-consumer.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'CrmNewEnergy',params:{lang:$i18n.locale}}">{{$t('solution_crm.new-energy.title')}}</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-5 col-md-5 offset-lg-2 offset-md-2">
                            <h4 class="title sub-title mt--10">Dynamics ERP</h4>
                            <Separator class="mb--20 mt--20 " style="background:  #E0E2E9;" />
                            <ul class="submenu row row--0 pl--0">
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'Semiconductor',params:{lang:$i18n.locale}}">{{$t('solution.semiconductor.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'Education',params:{lang:$i18n.locale}}">{{$t('solution.education.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'Disperse',params:{lang:$i18n.locale}}">{{$t('solution.disperse.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'RetailFMCG',params:{lang:$i18n.locale}}">{{$t('solution.retail.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'AutomobileAccessory',params:{lang:$i18n.locale}}">{{$t('solution.automobile.title')}}</router-link></li>
                                <li class="col-lg-3 col-md-3 p-3 pl--0"><router-link :to="{name:'Medicine',params:{lang:$i18n.locale}}">{{$t('solution.medicine.title')}}</router-link></li>
                            </ul>
                        </div>
                       
                    </div>
                </div>
            </div>
          </li>
        
        <li class="with-megamenu has-menu-child-item">
            <a href="javascript:;">
                {{$t('product.title')}}
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div class="rn-megamenu">
                <div class="container wrapper">
                    <h4 class="title">
                        <span>{{$t('product.subTitle')}}</span>
                        <!-- <span class="remark">PRODUCT</span> -->
                    </h4>
                    <ul class="row row--0 pl--0">
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungCPQ',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungCPQ.title')}}</span></router-link></li>
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungFCST',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungFCST.title')}}</span></router-link></li>
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungLoyalty',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungLoyalty.title')}}</span></router-link></li>
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungLTC',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungLTC.title')}}</span></router-link></li>
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungService',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungService.title')}}</span></router-link></li>
                        <li class="col-lg-4 single-mega-item"><router-link :to="{name:'VyungWorkflow',params:{lang:$i18n.locale}}"><span>{{$t('product.VyungWorkflow.title')}}</span></router-link></li>
                    </ul>
                </div>
            </div>
        </li>
        <li><router-link :to="{name:'service',params:{lang:$i18n.locale}}">{{$t('service.title')}}</router-link></li>
        <li><router-link :to="{name:'cases',params:{lang:$i18n.locale}}">{{$t('cases.title')}}</router-link></li>
        <li><router-link :to="{name:'news',params:{lang:$i18n.locale}}">{{$t('news.title')}}</router-link></li>
        <li v-if="$i18n.locale==='zh_CN'"><router-link :to="{name:'overseas',params:{lang:$i18n.locale}}">{{$t('overseas.title')}}</router-link></li>
        <li><router-link :to="{name:'about_us',params:{lang:$i18n.locale}}">{{$t('about_us.title')}}</router-link></li>
    </ul>
</template>

<script>
  
    import Icon from "../../icon/Icon";
    import Separator from "../../elements/separator/Separator";
    export default {
        name: 'Nav',
        components: {Icon,Separator},
    }
</script>